<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <!--    <a-alert banner>-->
    <!--      <template #message>-->
    <!--        dfdf-->
    <!--      </template>-->
    <!--    </a-alert>-->
    <router-view @setAppClasses="setAppClasses"></router-view>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import mixin from "@/views/mixin/mixin"
import axios from "@/axios"

const firebaseConfig = {
  apiKey: "AIzaSyBz8TPvKl7qk6XIuTnYrO-ZwcxJJ-Qqo6w",
  authDomain: "iralex.firebaseapp.com",
  projectId: "iralex",
  storageBucket: "iralex.appspot.com",
  messagingSenderId: "986858475219",
  appId: "1:986858475219:web:196b303393db1e234e4e26",
  measurementId: "G-XKWN49HSMZ"
};
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();
messaging.usePublicVapidKey('BA9HeUeVFCJAp3yoNlzBSHJkmRzwTbmdBjaS7kRi0Q_hQzROkx4irgJCADMYg2b2VMj8K_DyKxlm-JBDblfn9oo');

export default {
  mixins: [mixin],
  data() {
    return {
      vueAppClasses: [],
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    initialize() {
      if (!('serviceWorker' in navigator)) {
        console.warn('serviceWorker not working')
        return
      }
      if (!('PushManager' in window)) {
        console.warn('PushManager not working')
        return
      }
    },

    requestPermission() {
      Notification.requestPermission().then((permission) => {
        console.log(permission)
        if (permission === 'granted') {
          console.log('Notification permission granted.');
        }
      })
    },

    toggleClassInBody(className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
  },

  mounted() {
    messaging.requestPermission().then(() => {
      return messaging.getToken();
    }).then((token) => {
      this.$store.commit('TOKEN_MESSAGES', token)
    }).catch((reason) => {
      console.log(reason, 'ssssssssssss')
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register(`/app/firebase-messaging-sw.js`)
        .then(reg => {
          messaging.useServiceWorker(reg);
        })
        .catch(error => {
          const msg = `Service Worker Error (${error})`;
          console.error(msg);
        });
    }

    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    this.requestPermission()

    //  Initialize the template type.
    this.$store.dispatch('settings/initConfigurations')
  },

  async created() {
    // this.initialize()
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)
    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeMount() {
    const urls = [
      '/app/login',
      '/app/register',
      '/app/verify',
      '/app/forgot-password',
      '/app/reset-password'
    ]
    if (!urls.includes(window.location.pathname))
      window.addEventListener('beforeunload', this.getPermissions())
  },

  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>

<style>
body {
  background: #ECEFF8 !important;
  /*font-family: 'Montserrat' !important;*/
}

.vue-back-to-top {
  bottom: 10% !important;
}
</style>
